(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // click-directive to show info about patient and appointment 
    module.directive('agendaAppointmentDeleted', ['AppointmentDetailService', function (AppointmentDetailService) {
        var directive = {
            restrict: 'E',
            scope: {
                deleter: '@',
                deleteDate: '@'
            },
            templateUrl: '/app/agenda/templates/agenda-appointment-deleted.template.html'

        };
        return directive;
      
    }]);

})();